//
import { RFormFields } from '@/components/reusable_components/next'
import { RequiredRule, PasswordRule } from '@/mixins/reusable_mixins/rules'

//
export default props => new RFormFields(
    {
        name: 'rut',
        type: 'rut-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Rut',
            readonly: true,
        },
        variant: ['password'],
    },
    {
        name: 'name_case',
        type: 'text-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Nombre',
            readonly: true,
        },
        variant: ['password'],
    },
    {
        name: 'email',
        type: 'text-field',
        flex: {
            md6: true,
            lg5: true,
        },
        props: {
            label: 'Correo electronico',
            readonly: true,
        },
        variant: ['password'],
    },
    {
        name: 'password',
        type: 'password-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Nueva contraseña',
            rules: [RequiredRule, PasswordRule],
            type: 'password',
        },
        slots: {
            'append': 'new-password-append',
        },
        variant: ['password'],
    },
    {
        name: 'password_repeat',
        type: 'password-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Repetir nueva contraseña',
            rules: [RequiredRule, PasswordRule],
            type: 'password',
        },
        variant: ['password'],
    },
)
